<template>
  <div class="row">
    <div class="col-12">
      <template v-if="!prestationsForSelectedType">
        <div class="loading loading--mini">
          <div class="loading__loader">
            <inline-svg src="/images/icones/icon_loader.svg" />
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="prestationsForSelectedType.length > 0">
          <h2 class="h--headingM">Pour quelle prestation de soin {{ typeDeSoin }} ? <span class="asterix">*</span></h2>
          <VueSelect
            v-model="prestationStore"
            :options="prestationsForSelectedType"
            :getOptionLabel="(option) => option.name"
            :getOptionValue="(option) => option.key"
            :isSearchable="false"
            :isClearable="false"
            placeholder="Choisissez une prestation"
            @option-selected="onTypePrestationChange"
          />
          <!-- <select class="form-select" :class="{ 'form-select--disabled': prestationStore === null }" v-model="prestationStore" @change="onTypePrestationChange" :disabled="!prestationsForSelectedType || prestationsForSelectedType.length === 0">
            <option :value="null" selected disabled>Choisissez une prestation</option>
            <option v-for="(prestation, index) in prestationsForSelectedType" :key="index" :value="prestation.key">
              {{ prestation.name }}
            </option>
          </select> -->
        </template>
        <template v-else>
          Aucune prestation n'a été trouvée avec la combinaison du type de dépense ({{ typeDepenseStore }}), du code client ({{ clientCode }}) et du régime
          sélectionné ({{ typeRegime }})
        </template>
      </template>
      <!-- Info Bloc -->
      <div
        class="infoBloc mt-4"
        v-if="this.prestationStore === 'MontureVerresSimplesHorsCentPourCentSante' || this.prestationStore === 'MontureVerresComplexesHorsCentPourCentSante'"
      >
        <div class="infoBloc__icon">
          <inline-svg src="/images/icones/icon_information.svg" />
        </div>
        <p class="infoBloc__text">
          Verres simples pour corriger la vue de loin ou de près. La correction est comprise entre
          {{ this.prestationStore === "MontureVerresSimplesHorsCentPourCentSante" ? "-6 et +6" : "-4 et +4" }} dioptries.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import simulateurService from "@/services/simulateurService";
import { buildLabel, mapTypePrestation, mapTypeSoin, pushSimulationEvent } from "@/helpers/matomo";
import { normalizeRouteContext } from "@/helpers/entrySource";
import useVuelidate from "@vuelidate/core";
import VueSelect from "vue3-select-component";
import "vue3-select-component/styles";

export default {
  name: "EtapePrestation",
  components: { VueSelect },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    const routeContext = normalizeRouteContext(this.$route.params);

    return {
      // Données de l'URL
      clientCode: this.$route.params.clientCode,
      sourceEntree: routeContext.sourceEntree,
      typeRegime: routeContext.typeRegime,

      prestationsList: [],
      prestationsForSelectedType: [],
    };
  },
  computed: {
    typeDepenseStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/typeDepense"];
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updateTarification", value);
      },
    },
    prestationStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/prestation"] ? this.$store.getters["dataSimulateurStore/prestation"].key : null;
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updatePrestation", value);
      },
    },
    typeDeSoin() {
      switch (this.typeDepenseStore) {
        case 0:
          return "dentaire";
        case 1:
          return "optique";
        case 2:
          return "courant";
        case 3:
          return "hospitalier";
      }
    },
  },
  async mounted() {
    console.debug("Component Prestation is mounted!");

    // Charger les données initiales
    await this.getPrestationsForSelectedType();
  },
  methods: {
    async getPrestationsForSelectedType() {
      this.prestationsList = await simulateurService.getPrestations(this.clientCode, this.typeRegime, this.typeDepenseStore);
      if (this.typeDepenseStore === 0) {
        //Suppression des prestation Couronne pour en mettre des personnalisées afin de personnaliser aussi la tarification
        this.prestationsForSelectedType = this.prestationsList.map((item) => {
          if (item.key === "CouronneCeramoMetalliqueCentPourCentSante") {
            return {
              key: "TarifNonDefiniTotal",
              value: 1000,
              name: "Couronne sur incisive, canine ou 1e prémolaire",
            };
          }

          if (item.key === "CouronneCeramoMetalliqueTarifMaitrise") {
            return {
              key: "TarifNonDefiniSemi",
              value: 1001,
              name: "Couronne sur 2ème prémolaire",
            };
          }

          if (item.key === "CouronneCeramoMetalliqueTarifLibre") {
            return {
              key: "TarifDefini",
              value: 1002,
              name: "Couronne sur molaire",
            };
          }

          return item;
        });
      } else {
        this.prestationsForSelectedType = this.prestationsList;
      }

      this.$store.dispatch("dataSimulateurStore/updatePrestationsAll", this.prestationsList);
    },

    onTypePrestationChange(option) {
      const value = option.value;
      //On stock l'objet complet afin de faire le choix de la conf après pour les couronnes, en fonction du tarif choisis
      const selectedPrestation = this.prestationsForSelectedType.find((item) => item.key === value);
      this.prestationStore = selectedPrestation;

      const typeSoin = mapTypeSoin(this.typeDepenseStore);
      const typePrestation = mapTypePrestation(selectedPrestation);

      pushSimulationEvent({
        event: "choix_prestation",
        action: "choix_prestation",
        label: buildLabel({
          typeSoin,
          typePrestation,
          includeTarification: false,
        }),
        payload: {
          type_soin: typeSoin,
          type_prestation: typePrestation,
        },
      });

      //Si Couronne sur molaire, alors il n'y a pas de choix à faire sur le Tarif sinon le user fera son choix après
      if (value === "TarifDefini") {
        this.typeDepenseStore = value;
      } else {
        this.typeDepenseStore = null;
      }
    },
  },
  watch: {
    async typeDepenseStore(newValue, oldValue) {
      await this.getPrestationsForSelectedType();
    },
  },
};
</script>
